document.addEventListener("DOMContentLoaded", function (event) {
  // video lazy load
  $("video").lazy();

  // mobile summer sale 2 slider
  var mob_icon_text_slider = new Swiper(".mob_icon_text_slider", {
    autoHeight: false,
    calculateHeight: true,
    pagination: {
      el: ".mob_icon_text_dots",
    },
  });

  // support Template scroll
  $(window).scroll(function () {
    if ($(this).scrollTop() > 30) {
      $(".sticky").addClass("sticky_on");
    } else {
      $(".sticky").removeClass("sticky_on");
    }

    var getHeight = $(".support_content").height();
    if ($(this).scrollTop() > getHeight - 80) {
      $(".sticky").removeClass("sticky_on");
    }
  });

  var SupportStickyNav = class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const triggers = this.querySelectorAll("button");
      const sections = document
        .querySelector("#SupportPage-Main")
        .querySelectorAll("h3");
      this.scrollIntoView();
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const target = entry.target;
            if (entry.isIntersecting) {
              triggers.forEach((trigger) => {
                trigger.classList.remove("is-active");
                if (
                  trigger.textContent.trim() === entry.target.textContent.trim()
                ) {
                  trigger.classList.add("is-active");
                }
              });
            }
          });
        },
        {
          rootMargin: "-100px 0% -95% 0%",
        }
      );
      sections.forEach((section) => {
        observer.observe(section);
      });
    }

    scrollIntoView() {
      const triggers = this.querySelectorAll("button");
      const sections = document
        .querySelector("#SupportPage-Main")
        .querySelectorAll("h3");

      triggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          sections.forEach((section) => {
            if (section.textContent.trim() === trigger.textContent.trim()) {
              const offset = 90; // Offset in pixels
              const elementPosition = section.getBoundingClientRect().top;
              const offsetPosition =
                elementPosition + window.pageYOffset - offset;

              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              });
            }
          });
        });
      });
    }
  };

  window.customElements.define("support-sticky-nav", SupportStickyNav);

  // home page tab section
  const tabs = document.querySelector(".template-index .wrapper");
  if (tabs) {
    const tabButton = document.querySelectorAll(".tab-button");
    const contents = document.querySelectorAll(".content_tab");

    tabs.onclick = (e) => {
      const id = e.target.dataset.id;
      if (id) {
        tabButton.forEach((btn) => {
          btn.classList.remove("active");
        });
        e.target.classList.add("active");

        contents.forEach((content) => {
          content.classList.remove("active");
        });
        const element = document.getElementById(id);
        element.classList.add("active");
      }
    };
  }

  // custom tab embed start
  const allTabsEmbed = document.querySelectorAll(".custom-tab-embed");
  if (allTabsEmbed.length > 0) {
    allTabsEmbed.forEach((tabContainer) => {
      // 获取当前容器内的所有元素
      const elements = {
        outer: {
          buttons: tabContainer.querySelectorAll(".custom-tab-embed .tab-button"),
          contents: tabContainer.querySelectorAll(".custom-tab-embed .content_tab"),
          bottomButtons: tabContainer.querySelectorAll(".custom-tab-embed .bottom-button")
        },
        inner: {
          buttons: tabContainer.querySelectorAll(".custom-tab-embed .tab-button_inner"),
          contents: tabContainer.querySelectorAll(".custom-tab-embed .content_tab_inner")
        }
      };

      // 辅助函数：移除所有元素的 active 状态
      const removeActiveClass = (elementList) => {
        if (elementList.length > 0) {
          elementList.forEach(element => element.classList.remove("active"));
        }
      };

      // 辅助函数：激活内层第一个元素
      const activateInnerFirst = (contentElement) => {
        const firstInnerButton = contentElement.querySelector(".tab-button_inner");
        const firstInnerContent = contentElement.querySelector(".content_tab_inner");
        
        if (firstInnerButton && firstInnerContent) {
          removeActiveClass(elements.inner.buttons);
          removeActiveClass(elements.inner.contents);
          firstInnerButton.classList.add("active");
          firstInnerContent.classList.add("active");
        }
      };

      // 外层 tab 按钮事件
      elements.outer.buttons.forEach((btn) => {
        btn.onclick = (e) => {
          const id = e.target.dataset.id;
          if (id) {
            // 处理外层状态
            removeActiveClass(elements.outer.buttons);
            removeActiveClass(elements.outer.contents);
            removeActiveClass(elements.outer.bottomButtons);
            e.target.classList.add("active");
            
            const targetElement = document.getElementById(id);
            if (targetElement) {
              targetElement.classList.add("active");
              // 自动激活内层第一个元素
              activateInnerFirst(targetElement);
              // 激活 targetElement 的下一个 bottom-button
              const nextBottomButton = targetElement.nextElementSibling;
              if (nextBottomButton && nextBottomButton.classList.contains('bottom-button')) {
                nextBottomButton.classList.add("active");
              }
            }
          }
        };
      });

      // 内层 tab 按钮事件
      elements.inner.buttons.forEach((btn) => {
        btn.onclick = (e) => {
          const id = e.target.dataset.id;
          if (id) {
            // 处理内层状态
            removeActiveClass(elements.inner.buttons);
            removeActiveClass(elements.inner.contents);
            e.target.classList.add("active");
            
            const targetElement = document.getElementById(id);
            if (targetElement) {
              targetElement.classList.add("active");
            }
          }
        };
      });
    });
  }
  // custom tab embed end

  //home page video play pause
  const videos = document.querySelectorAll(".video");
  const playButtons = document.querySelectorAll(".play-gif");
  let currentVideo = null;

  function togglePlay(video) {
    if (video.paused || video.ended) {
      video.play();
      if (currentVideo && currentVideo !== video) {
        currentVideo.pause();
      }
      currentVideo = video;
    } else {
      video.pause();
      currentVideo = null;
    }
  }

  function pauseOtherVideos(clickedVideo) {
    videos.forEach((video) => {
      if (video !== clickedVideo) {
        video.pause();
      }
    });
  }

  playButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      const video = videos[index];
      togglePlay(video);
    });
  });

  videos.forEach((video) => {
    video.addEventListener("click", function () {
      pauseOtherVideos(this);
    });

    video.addEventListener("playing", function () {
      currentVideo = this; // Update the current video when it starts playing
      const playButton = this.parentElement.querySelector(".play-gif");
      if (playButton) {
        playButton.style.opacity = 0;
      }
    });

    video.addEventListener("pause", function () {
      const playButton = this.parentElement.querySelector(".play-gif");
      if (playButton) {
        playButton.style.opacity = 1;
      }
    });
  });

  videos.forEach((video) => {
    video.addEventListener("click", function () {
      if (this.paused) {
        this.play();
      } else {
        this.pause();
      }
      pauseOtherVideos(this);
    });
  });

  // home page video slider
  const video_item = document.querySelector(".template-index .video_grid_main");
  if (video_item) {
    const slider_video = document.querySelector(".video_grid_main");
    const track_video = slider_video.querySelector(".video_grid");
    const dotsContainer_video = slider_video.querySelector(
      ".slider__video__dots"
    );
    const dots_video = dotsContainer_video.querySelectorAll(".dot_v_item");

    if (track_video) {
      track_video.addEventListener("scroll", () => {
        updateDots();
      });

      dots_video.forEach((dot) => {
        dot.addEventListener("click", () => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          track_video.scrollTo({
            left: dotIndex * track_video.firstElementChild.offsetWidth,
            behavior: "smooth",
          });
        });
      });

      function updateDots() {
        const currentSlideIndex = Math.round(
          track_video.scrollLeft / track_video.firstElementChild.offsetWidth
        );
        dots_video.forEach((dot) => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          if (dotIndex === currentSlideIndex) {
            dot.classList.add("active");
          } else {
            dot.classList.remove("active");
          }
        });
      }
    }
  }
  // what on the menu section slider js

  const columnGrid = document.querySelector(
    ".template-index .columnGrid__inner"
  );
  if (columnGrid) {
    const _slider = document.querySelector(".columnGrid__inner");
    const _track = _slider.querySelector(".columnGridList");
    const dotsContainer = _slider.querySelector(".slider__dots");
    const dots = dotsContainer.querySelectorAll(".dot_item");

    if (_track) {
      _track.addEventListener("scroll", () => {
        updateDots();
      });

      dots.forEach((dot) => {
        dot.addEventListener("click", () => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          _track.scrollTo({
            left: dotIndex * _track.firstElementChild.offsetWidth,
            behavior: "smooth",
          });
        });
      });

      function updateDots() {
        const currentSlideIndex = Math.round(
          _track.scrollLeft / _track.firstElementChild.offsetWidth
        );
        dots.forEach((dot) => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          if (dotIndex === currentSlideIndex) {
            dot.classList.add("active");
          } else {
            dot.classList.remove("active");
          }
        });
      }
    }
  }

  // tab one slider

  const tab_slider_main = document.querySelector(
    ".template-index .tab_slider_main_1"
  );
  if (tab_slider_main) {
    const slider_tab = document.querySelector(".tab_slider_main_1");
    const track_tab = slider_tab.querySelector(".tab_slider_content");
    const dotsContainer_tab = slider_tab.querySelector(".slider__dots__tab_1");
    const dots_tab = dotsContainer_tab.querySelectorAll(".tab_dots_1");

    if (track_tab) {
      track_tab.addEventListener("scroll", () => {
        updateDots();
      });

      dots_tab.forEach((dot) => {
        dot.addEventListener("click", () => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          // alert(dotIndex);
          track_tab.scrollTo({
            left: dotIndex * track_tab.firstElementChild.offsetWidth,
            behavior: "smooth",
          });
        });
      });

      function updateDots() {
        const currentSlideIndex = Math.round(
          track_tab.scrollLeft / track_tab.firstElementChild.offsetWidth
        );
        dots_tab.forEach((dot) => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          if (dotIndex === currentSlideIndex) {
            dot.classList.add("active");
          } else {
            dot.classList.remove("active");
          }
        });
      }
    }
  }

  // Product Tab Section Slider

  const tab_slider = document.querySelector(
    ".template-index .tab_slider_main_2"
  );
  if (tab_slider) {
    const slider_tab_two = document.querySelector(".tab_slider_main_2");
    const track_tab_two = slider_tab_two.querySelector(".tab_slider_content");
    const dotsContainer_tab_two = slider_tab_two.querySelector(
      ".slider__dots__tab_2"
    );
    const dots_tab_two = dotsContainer_tab_two.querySelectorAll(".tab_dots_2");

    if (track_tab_two) {
      track_tab_two.addEventListener("scroll", () => {
        updateDots();
      });

      dots_tab_two.forEach((dot) => {
        dot.addEventListener("click", () => {
          // alert();
          const dotIndex = parseInt(dot.dataset.sliderDot);
          track_tab_two.scrollTo({
            left: dotIndex * track_tab_two.firstElementChild.offsetWidth,
            behavior: "smooth",
          });
        });
      });

      function updateDots() {
        const currentSlideIndex = Math.round(
          track_tab_two.scrollLeft / track_tab_two.firstElementChild.offsetWidth
        );
        dots_tab_two.forEach((dot) => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          if (dotIndex === currentSlideIndex) {
            dot.classList.add("active");
          } else {
            dot.classList.remove("active");
          }
        });
      }
    }
  }

  // coll slider list slider
  const coll_list_slider = document.querySelector(
    ".template-index .coll_list_slider"
  );
  if (coll_list_slider) {
    const slider_col = document.querySelector(".coll_list_slider");
    const track_col = slider_col.querySelector(".collectionSliderList");
    const dotsContainer_col = slider_col.querySelector(".slider__coll__dots");
    const dots_col = dotsContainer_col.querySelectorAll(".dot_coll_item");

    if (track_col) {
      track_col.addEventListener("scroll", () => {
        updateDots();
      });

      dots_col.forEach((dot) => {
        dot.addEventListener("click", () => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          track_col.scrollTo({
            left: dotIndex * track_col.firstElementChild.offsetWidth,
            behavior: "smooth",
          });
        });
      });

      function updateDots() {
        const currentSlideIndex = Math.round(
          track_col.scrollLeft / track_col.firstElementChild.offsetWidth
        );
        dots_col.forEach((dot) => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          if (dotIndex === currentSlideIndex) {
            dot.classList.add("active");
          } else {
            dot.classList.remove("active");
          }
        });
      }
    }
  }

  //========hasMegamenuChildList hover ===============//
  function menuChildListLoop() {
    const MegamenuChilLength = document.querySelectorAll(
      ".hasMegamenuChildList"
    );
    if (MegamenuChilLength.length || MegamenuChilLength != null) {
      MegamenuChilLength.forEach((details) => {
        if (details.getAttribute("open") != null) {
        } else {
          details.setAttribute("open", "");
        }
      });
    }
  }
  var interval = self.setInterval(function () {
    menuChildListLoop();
  }, 80);

  let items = document
    .querySelector(".header__icon--support .header__inline-menu")
    .querySelectorAll("details");
  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });

  // ----------customfeatureimage-----------//
  const imageOvrelayBtn = document.querySelectorAll(
    ".img-wrp .svg-wrp .imageOvrelaybtn"
  );
  if (imageOvrelayBtn != null) {
    // const imageOvrelayText = document.querySelectorAll('.img-wrp .image-ovrelayContent');
    imageOvrelayBtn.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const imageOvrelayText = button.closest(".img-wrp");
        // button.classList.remove("is--active");
        if (button.classList.contains("is--active")) {
          button.classList.remove("is--active");
          imageOvrelayText
            .querySelector(".image-ovrelayContent")
            .classList.remove("is--active");
        } else {
          // imageOvrelayBtn.classList.remove("is--active");
          button.classList.add("is--active");
          imageOvrelayText
            .querySelector(".image-ovrelayContent")
            .classList.add("is--active");
        }
      });
    });
  }

  const chimiChurriSauce = document.querySelector(".chimichurri_sauce");
  // recipe page hover text
  if (chimiChurriSauce != null) {
    document
      .querySelector(".chimichurri_sauce p:first-child strong:first-child")
      .addEventListener("mouseover", () => {
        document
          .querySelector(".chimichurri_sauce")
          .querySelector(".chimichurri_description").style.display =
          "inline-block";
      });

    document
      .querySelector(".chimichurri_sauce p:first-child strong:first-child")
      .addEventListener("mouseout", () => {
        document
          .querySelector(".chimichurri_sauce")
          .querySelector(".chimichurri_description").style.display = "none";
      });

    document
      .querySelector(".marbling_text p:first-child strong")
      .addEventListener("mouseover", () => {
        document
          .querySelector(".marbling_text")
          .querySelector(".marbling_description").style.display =
          "inline-block";
      });

    document
      .querySelector(".marbling_text p:first-child strong")
      .addEventListener("mouseout", () => {
        document
          .querySelector(".marbling_text")
          .querySelector(".marbling_description").style.display = "none";
      });
  }

  // recipe page featured product  slider
  const fe_list_slider = document.querySelector(".featured_products");
  if (fe_list_slider) {
    const slider_fe = document.querySelector(".featured_products");
    const track_fe = slider_fe.querySelector(".featured_product_slider");
    const featured_dots = slider_fe.querySelector(".featured_dots");
    const dots_fe = featured_dots.querySelectorAll(".fe_dotes_item");

    if (track_fe) {
      track_fe.addEventListener("scroll", () => {
        updateDots();
      });

      dots_fe.forEach((dot) => {
        dot.addEventListener("click", () => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          track_fe.scrollTo({
            left: dotIndex * track_fe.firstElementChild.offsetWidth,
            behavior: "smooth",
          });
        });
      });

      function updateDots() {
        const currentSlideIndex = Math.round(
          track_fe.scrollLeft / track_fe.firstElementChild.offsetWidth
        );
        dots_fe.forEach((dot) => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          if (dotIndex === currentSlideIndex) {
            dot.classList.add("active");
          } else {
            dot.classList.remove("active");
          }
        });
      }
    }
  }

  // recipe page ingredients on load
  const fractionMap = {
    0.125: { numerator: 1, denominator: 8 },
    0.142: { numerator: 1, denominator: 7 },
    0.166: { numerator: 1, denominator: 6 },
    0.2: { numerator: 1, denominator: 5 },
    0.25: { numerator: 1, denominator: 4 },
    0.333: { numerator: 1, denominator: 3 },
    0.375: { numerator: 3, denominator: 4 },
    0.4: { numerator: 2, denominator: 5 },
    0.5: { numerator: 1, denominator: 2 },
    0.6: { numerator: 3, denominator: 5 },
    0.666: { numerator: 2, denominator: 3 },
    0.75: { numerator: 3, denominator: 4 },
    0.8: { numerator: 4, denominator: 5 }
  };
  function pointToFraction (element, value) {
    if (element && value) {
      const formattedValue = parseFloat(value.toFixed(3));
      const fraction = fractionMap[formattedValue];
      if (fraction) {
        element.html(`<span class="divide_text"><sup>${fraction.numerator}</sup>/<sub>${fraction.denominator}</sub></span>`);
      } else {
        const displayValue = formattedValue === 0.999 ? 1 : parseFloat(value.toFixed(2));
        element.text(displayValue);
      }
    }
  }

  $(".recipe_item_main ul li .ingredients_checkbox_item .recipe_number").each(function() {
    pointToFraction($(this), parseFloat($(this).data("value")))
  });

  // recipe page ingredients click
  $(document).on("click", ".unit_item .pair-item", function () {
    $(this).closest(".unit_item").find(".pair-item").removeClass("active");
    $(this).addClass("active");
    var data = parseFloat($(this).data("title"));
    var serving_value = parseFloat($(".serving_number span").data("serving"));
    var final_serving = data * serving_value;
    $(".serving_number span").html(final_serving);

    $(".recipe_item_main ul li .ingredients_checkbox_item .recipe_number").each(function () {
      var value = parseFloat($(this).data("value"));
      var final = data * value;
      pointToFraction($(this), final)
    });
  });

  // click add class active
  $(document).on("change", "#need_item ul li label", function () {
    $(this).toggleClass("line_active");
  });

  $(document).on("change", "#recipe_input_item  ul li label", function () {
    $(this).toggleClass("line_active");
  });

  // Popup show
  $(document).on("click", ".richtext_with_popup .button", function (event) {
    $(".request_recipe_popup").fadeIn();
      event.preventDefault();
  });
  $(document).on("click", ".popup_close", function (event) {
    $(this).closest(".request_recipe_popup").hide();
  });

  // Recipe Print
  // $(document).on("click", "#dc_print_btn", function(event) {
  //     event.preventDefault();
  //     var printContents = document.querySelector('.recipe-ingredients-section').innerHTML;
  //     var recipe_text = document.querySelector('.instruction-div').innerHTML;

  //     var originalContents = document.body.innerHTML;

  //     document.body.innerHTML = printContents + recipe_text;

  //     window.print();
  //     document.body.innerHTML = originalContents;
  // });

  $(document).on("click", "#dc_print_btn", function (event) {
    event.preventDefault();
    $(".recipe-ingredients-section , .instruction-div").printThis({
      importCSS: true,
      loadCSS: [
        "//cdn.shopify.com/s/files/1/0524/2113/2440/t/71/assets/print.css?67493",
      ],
    });
  });

  // recipe page blog slider with Arrow and Dots

  const blog_slider = document.querySelector(".blog_slider");
  if (blog_slider) {
    const blog_slider_main = document.querySelector(".featured_blog_section");
    const track = blog_slider.querySelector(".blog__posts_track");
    const blog_prev = blog_slider.querySelector("[data-slider-prev]");
    const next = blog_slider_main.querySelector("[data-slider-next]");
    const blog_dots = blog_slider_main.querySelector(".dotes_article_main");
    const article_dots_item = blog_dots.querySelectorAll(".article_dots_item");

    if (track) {
      blog_prev.addEventListener("click", () => {
        next.removeAttribute("disabled");

        track.scrollTo({
          left: track.scrollLeft - track.firstElementChild.offsetWidth,
          behavior: "smooth",
        });
      });

      next.addEventListener("click", () => {
        blog_prev.removeAttribute("disabled");

        track.scrollTo({
          left: track.scrollLeft + track.firstElementChild.offsetWidth,
          behavior: "smooth",
        });
      });

      track.addEventListener("scroll", () => {
        const trackScrollWidth = track.scrollWidth;
        const trackOuterWidth = track.clientWidth;

        blog_prev.removeAttribute("disabled");
        next.removeAttribute("disabled");

        if (track.scrollLeft <= 0) {
          blog_prev.setAttribute("disabled", "");
        }

        if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
          next.setAttribute("disabled", "");
        }
      });

      track.addEventListener("scroll", () => {
        updateDots();
      });
    }

    article_dots_item.forEach((dot) => {
      dot.addEventListener("click", () => {
        const dotIndex = parseInt(dot.dataset.sliderDot);
        track.scrollTo({
          left: dotIndex * track.firstElementChild.offsetWidth,
          behavior: "smooth",
        });
      });
    });

    function updateDots() {
      const currentSlideIndex = Math.round(
        track.scrollLeft / track.firstElementChild.offsetWidth
      );
      article_dots_item.forEach((dot) => {
        const dotIndex = parseInt(dot.dataset.sliderDot);
        if (dotIndex === currentSlideIndex) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    }
  }

  // Vesync app Page slider
  const swiper = new Swiper(".custom-slider-new-imageText", {
    slidesPerView: "auto",
    cssMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "fraction",
    },
    navigation: {
      nextEl: ".nextArrow",
      prevEl: ".prevArrow",
    },
  });

  // product page Specs Popup
  $(document).on("click", ".specs_btn", function () {
    $(this)
      .closest(".product-specs-main")
      .find(".product-specs-popup")
      .fadeIn();
    $("body").addClass("scroll_off");
  });
  $(document).on("click", ".specs_close", function () {
    $(this)
      .closest(".product-specs-main")
      .find(".product-specs-popup")
      .fadeOut();
    $("body").removeClass("scroll_off");
  });

  // multicolumn custom slider

  const blog_slider_main = document.querySelector(".custom-multicolumn_slider");

  if (blog_slider_main) {
    const track = blog_slider_main.querySelector(".column_slidebar");
    const blog_prev = blog_slider_main.querySelector("[data-slider-prev]");
    const next = blog_slider_main.querySelector("[data-slider-next]");
    const blog_dots = blog_slider_main.querySelector(".dotes_article_main");
    const article_dots_item = blog_dots.querySelectorAll(".article_dots_item");

    if (track) {
      blog_prev.addEventListener("click", () => {
        next.removeAttribute("disabled");

        track.scrollTo({
          left: track.scrollLeft - track.firstElementChild.offsetWidth,
          behavior: "smooth",
        });
      });

      next.addEventListener("click", () => {
        blog_prev.removeAttribute("disabled");

        track.scrollTo({
          left: track.scrollLeft + track.firstElementChild.offsetWidth,
          behavior: "smooth",
        });
      });

      track.addEventListener("scroll", () => {
        const trackScrollWidth = track.scrollWidth;
        const trackOuterWidth = track.clientWidth;

        blog_prev.removeAttribute("disabled");
        next.removeAttribute("disabled");

        if (track.scrollLeft <= 0) {
          blog_prev.setAttribute("disabled", "");
        }

        if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
          next.setAttribute("disabled", "");
        }
      });

      track.addEventListener("scroll", () => {
        updateDots();
      });
    }

    article_dots_item.forEach((dot) => {
      dot.addEventListener("click", () => {
        const dotIndex = parseInt(dot.dataset.sliderDot);
        track.scrollTo({
          left: dotIndex * track.firstElementChild.offsetWidth,
          behavior: "smooth",
        });
      });
    });

    function updateDots() {
      const currentSlideIndex = Math.round(
        track.scrollLeft / track.firstElementChild.offsetWidth
      );
      article_dots_item.forEach((dot) => {
        const dotIndex = parseInt(dot.dataset.sliderDot);
        if (dotIndex === currentSlideIndex) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    }
  }

  // product page stikcy add to cart button
  $(document).on("click", ".product-header .add_cart", function () {
    $(this)
      .closest(".template-product")
      .find(
        ".product__info-wrapper .product-form__buttons .product-form__submit"
      )
      .click();
  });

  // blog filter section
  /*
      
      $(document).on('change','.option_list-tag select',function(event) {
        $('.hidden_option').empty();
        var selectedValues = [];
        $(".option_list-tag select option:selected").each(function(){
          var optionAvia = $(this).data('value'); 
          if(optionAvia){
            selectedValues.push(optionAvia);
          }
          
        });
        
        $('.hidden_option').append('<p class="optionList" data-value="' + selectedValues + '">' + selectedValues + '</p>');
        console.log(selectedValues); // Output the array of selected values
      });
        
      $(document).on('click','.filter_btn a',function(event) {
        event.preventDefault();
         var hiddenOption = $('.hidden_option p').data('value');
         var result = hiddenOption.includes(',');
         if(result){
           var splitAll = hiddenOption.replace(/,/g, "+");
           var find = '/search?type=article&q='+splitAll;
           window.location.href = find;
           $('.option_list-tag select option[data-attr="disabled-val"]').prop('selected', true);
         }else{
           var find = '/search?type=article&q='+hiddenOption;
           window.location.href = find;
           $('.option_list-tag select option[data-attr="disabled-val"]').prop('selected', true);
         }    
      });
    */

  // Select change blog filter
  $(document).on("change", ".option_list-tag select", function (event) {
    var optionAvia = $(this).find("option:selected").data("value");
    var find = "/blogs/recipes/tagged/" + optionAvia;
    window.location.href = find;
  });

  // coll slider list slider
  const custom_feature_slider = document.querySelector(
    ".custom-feature-slider-main"
  );
  if (custom_feature_slider) {
    const track_col = custom_feature_slider.querySelector(".image-block-outer");
    const dotsContainer_col = custom_feature_slider.querySelector(
      ".slider__coll__dots"
    );
    const dots_col = dotsContainer_col.querySelectorAll(".dot_coll_item");

    if (track_col) {
      track_col.addEventListener("scroll", () => {
        updateDots();
      });

      dots_col.forEach((dot) => {
        dot.addEventListener("click", () => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          track_col.scrollTo({
            left: dotIndex * track_col.firstElementChild.offsetWidth,
            behavior: "smooth",
          });
        });
      });

      function updateDots() {
        const currentSlideIndex = Math.round(
          track_col.scrollLeft / track_col.firstElementChild.offsetWidth
        );
        dots_col.forEach((dot) => {
          const dotIndex = parseInt(dot.dataset.sliderDot);
          if (dotIndex === currentSlideIndex) {
            dot.classList.add("active");
          } else {
            dot.classList.remove("active");
          }
        });
      }
    }
  }

  // Saved Blog in Local Storage
  var showList = [];
  $(document).on("click", ".save_recipe_btn", function () {
    if ($(this).hasClass("recipe_saved")) {
    } else {
      $(this).addClass("recipe_saved");

      var thshandle = $(this).attr("data-art");

      var showList = JSON.parse(localStorage.getItem("showList_item")) || [];
      var isDuplicate = showList.some(function (show) {
        return show.handle === thshandle;
      });

      if (!isDuplicate) {
        var show = {
          handle: thshandle,
        };
        showList.push(show);
        localStorage.setItem("showList_item", JSON.stringify(showList));
      }
    }
  });

  if (localStorage.getItem("showList_item")) {
    var get_array_data = JSON.parse(localStorage.getItem("showList_item"));
    var blog_lenght = get_array_data.length;
    var show_item = 6 - blog_lenght;
    // alert(blog_lenght);

    if (blog_lenght < 6) {
      $(".placeholder_list").slice(0, show_item).removeClass("hide_item");
    } else if (blog_lenght == 0) {
      $(".placeholder_list").removeClass("hide_item");
    }

    if (get_array_data.length > 0) {
      $.each(get_array_data, function (index, value) {
        var get_handle = value.handle;

        var show = {
          handle: get_handle,
        };
        showList.push(show);
        localStorage.setItem("showList_item", JSON.stringify(showList));
        // $('.account_active .saved_recipe_section').show();
        $(document)
          .find(".save_recipe_btn")
          .each(function () {
            var thsid = $(this).attr("data-value");
            if (thsid == get_handle) {
              $(this).addClass("recipe_saved");
            }
          });

        $(document)
          .find(".save_article_item")
          .each(function () {
            var thsid = $(this).attr("data-name");
            if (thsid == get_handle) {
              $(this).addClass("saved_item_show");
            }
          });
      });
    }
  } else {
    $(".placeholder_list").removeClass("hide_item");
  }

  $(document).on("click", ".save_recipe_btn.recipe_saved", function () {
    if ($("body").hasClass("temp-supx-saved-recipes")) {
      location.reload();
    }
    if ($(this).hasClass("recipe_saved")) {
      var showList = [];
      var showList_saved = [];

      $(this).removeClass("recipe_saved");

      var Gethandle = $(this).closest(".blog_recipe_btn").attr("data-art");
      if (localStorage.getItem("showList_item")) {
        var get_array_data = JSON.parse(localStorage.getItem("showList_item"));
        if (get_array_data.length > 0) {
          $.each(get_array_data, function (index, value) {
            var get_handle = value.handle;
            if (Gethandle == get_handle) {
              delete get_array_data[index];
              var countitems = 0;
              $.each(get_array_data, function (index, value) {
                if (value == undefined && value == null) {
                } else {
                  var show_set = {
                    handle: value.handle,
                  };
                  showList.push(show_set);
                  showList_saved[countitems] = value;
                  countitems++;
                }
              });
              localStorage.setItem(
                "showList_item",
                JSON.stringify(showList_saved)
              );
            }
          });
        }
      }
    }
  });

  // Recipe Collection Toggle Click
  $(document).on("click", ".search_filter-opn-btn", function () {
    $(this).toggleClass("active");
    $(this).closest(".toggle-with-blog-search").find(".blog-filters").toggle();
  });

  // Recipe Index Page Accordian Mobile
  function bindAccordionEvent() {
    if ($(window).width() < 767) {
      if (!window._acc_title_binded) {
        $(document).on('click.acc_title', '.acc_title', function (e) {
          var dropDown = $(this).closest('.multiple_recipe_parent').find('.recipe_index_column');
          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            dropDown.stop(false, true).slideUp();
          } else {
            $('.acc_title.active').removeClass('active');
            $('.recipe_index_column:visible').slideUp();
            $(this).addClass('active');
            dropDown.stop(false, true).slideDown();
          }
          e.preventDefault();
        });
        window._acc_title_binded = true;
      }
    } else {
      $(document).off('click.acc_title');
      window._acc_title_binded = false;
    }
  }
  
  bindAccordionEvent();
  $(window).on('resize', function () {
    bindAccordionEvent();
  });
  

  // Recipe Landing page Mobile Blog Slider
  // if ($(window).width() < 767) {
  //     var swiper_blog = new Swiper(".swiper_slide", {
  //         slidesPerView: 1,
  //         spaceBetween: 0,
  //         grabCursor: true,
  //         speed: 500,
  //         pagination: {
  //             el: '.slider__pagination',
  //             clickable: true,
  //         },
  //         navigation: {
  //             nextEl: '.slider__button-next',
  //             prevEl: '.slider__button-prev',
  //         },
  //     });
  // }

  // blog collection template image with slider
  var swiper_slide = new Swiper(".mySwiperslid", {
    spaceBetween: 30,
    effect: "fade",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // blog temp click
  $(document).on("click", ".block_href a", function () {
    // event.preventDefault();
    $(".block_href a.active").removeClass("active");
    $(this).addClass("active");
    var blogId = $(this).data("id");
    localStorage.setItem("blog_id", blogId);
    $(".main_blog-img").removeClass("active_tabs");
    var getBlogId = localStorage.getItem("blog_id");
    $('.main_blog-img[data-id="' + getBlogId + '"]').addClass("active_tabs");
    var url = $(location).attr("pathname");
    // alert(url);
    window.location.href = url;
  });

  var getBlogId = localStorage.getItem("blog_id");
  if (getBlogId != null) {
    if (getBlogId.length > 1) {
      $(".block_href a.active").removeClass("active");
      $('.block_href a[data-id="' + getBlogId + '"]').addClass("active");
      $(".main_blog-img").removeClass("active_tabs");
      $('.main_blog-img[data-id="' + getBlogId + '"]').addClass("active_tabs");
    }
  }

  // saved recipe page filter
  $(document).on("change", ".option_list-tag-select select", function (event) {
    var value = $(this).find("option:selected").data("value");
    var data_value_meal = $(this).find("option:selected").data("meal");
    var data_value_dietary = $(this).find("option:selected").data("dietary");
    var data_value_appliance = $(this)
      .find("option:selected")
      .data("appliance");
    var data_value_occasion = $(this).find("option:selected").data("occasion");
    var data_value_difficulty = $(this)
      .find("option:selected")
      .data("difficulty");
    var data_value_ingredients = $(this)
      .find("option:selected")
      .data("ingredients");

    $(".recipe__content .saved_item_show").hide();

    $(".recipe__content .saved_item_show").each(function () {
      if (data_value_meal == "meal") {
        var meal_value = $(this).data("meal");
        if (meal_value != "") {
          if (meal_value.indexOf(value) != -1) {
            $(this).show();
          }
        }
      }

      if (data_value_dietary == "dietary") {
        var dietary_value = $(this).data("dietary");
        if (dietary_value != "") {
          if (dietary_value.indexOf(value) != -1) {
            $(this).show();
          }
        }
      }

      if (data_value_appliance == "appliance") {
        var appliance_value = $(this).data("appliance");
        if (appliance_value != "") {
          if (appliance_value.indexOf(value) != -1) {
            $(this).show();
          }
        }
      }

      if (data_value_occasion == "occasion") {
        var occasion_value = $(this).data("occasion");
        if (occasion_value != "") {
          if (occasion_value.indexOf(value) != -1) {
            $(this).show();
          }
        }
      }

      if (data_value_difficulty == "difficulty") {
        var difficulty_value = $(this).data("difficulty");
        if (difficulty_value != "") {
          if (difficulty_value.indexOf(value) != -1) {
            $(this).show();
          }
        }
      }

      if (data_value_ingredients == "ingredients") {
        var ingredients_value = $(this).data("ingredients");
        if (ingredients_value != "") {
          if (ingredients_value.indexOf(value) != -1) {
            $(this).show();
          }
        }
      }
    });
  });

  // reset button on saved recipe page
  $(document).on("click", ".saved_reset_btn", function () {
    $(".recipe__content .saved_item_show").show();
  });

  // login popup
  $(document).on("click", ".login_account", function (event) {
    event.preventDefault();
    $(".custom_recipe_popup").show();
  });
  $(document).on("click", ".customer_pages", function (event) {
    event.preventDefault();
    $(".custom_recipe_popup").hide();
  });
  $(document).mouseup(function (e) {
    var container = $(".custom_recipe_popup");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".custom_recipe_popup").hide();
    }
  });

  // product page window scroll sticky cart show

  $(window).scroll(function () {
    if ($(".template-product").length) {
      var product_scroll_check = $(
        ".template-product .product-form__submit"
      ).offset().top;
      if ($(this).scrollTop() >= product_scroll_check) {
        $(".product_header_sticky").fadeIn();
      } else {
        $(".product_header_sticky").fadeOut();
      }
    }
  });

  // share popup js
  $(document).on(
    "click",
    ".instructions-btns-div .btn_parent:last-child .button",
    function (event) {
      event.preventDefault();
      $(".share_popup").show();
    }
  );
  $(document).on("click", ".share_popup .popup_close", function (event) {
    event.preventDefault();
    $(".share_popup").hide();
  });

  // share js
  var shareURL = encodeURIComponent(window.location.href);
  var shareText = encodeURIComponent("Check out this awesome content!");

  // Facebook
  $("#share-facebook").on("click", function (e) {
    e.preventDefault();
    var facebookURL =
      "https://www.facebook.com/sharer/sharer.php?u=" + shareURL;
    window.open(facebookURL, "facebook-share-dialog", "width=800,height=600");
  });

  // Twitter
  $("#share-twitter").on("click", function (e) {
    e.preventDefault();
    var twitterURL =
      "https://twitter.com/intent/tweet?url=" + shareURL + "&text=" + shareText;
    window.open(twitterURL, "twitter-share-dialog", "width=800,height=600");
  });

  // Pinterest
  $("#share-pinterest").on("click", function (e) {
    e.preventDefault();
    var pinterestURL =
      "https://pinterest.com/pin/create/button/?url=" +
      shareURL +
      "&description=" +
      shareText;
    window.open(pinterestURL, "pinterest-share-dialog", "width=800,height=600");
  });

  // Email
  $("#share-email").on("click", function (e) {
    e.preventDefault();
    var emailURL = "mailto:?subject=" + shareText + "&body=" + shareURL;
    window.location.href = emailURL;
  });

  // cart page edit option click
  // $(document).on("click", ".cart_edit .quick-add__submit", function (event) {
  //   event.preventDefault();
  //   const myTimeout = setTimeout(set_times, 1400);
  //   function set_times() {
  //     $(".quick-add-modal__content")
  //       .find(".product__info-wrapper")
  //       .removeClass("product_info_main");
  //     $(".quick-add-modal__content")
  //       .find(".product-form__submit")
  //       .css("opacity", "1")
  //       .find("span")
  //       .text("Update Item");
  //   }
  // });

  // $(document).on(
  //   "click",
  //   ".quick-add-modal__content .product-form__input input[type=radio]",
  //   function (event) {
  //     const myTimeout = setTimeout(set_time, 800);
  //     function set_time() {
  //       // $('.quick-add-modal__content').find('.product-form__submit span').text('');
  //       $(".quick-add-modal__content")
  //         .find(".product-form__submit span")
  //         .text("Update Item");
  //     }
  //   }
  // );

  // healthy-gourmet-air-fryer-recipes slider js
  var swipersection = new Swiper(".image-block-slider-section", {
    spaceBetween: 15,
    pagination: {
      el: ".image-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });
  // slider collection
  var collectionsliderswiper = new Swiper(".slider-collection", {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-collection-slider",
      prevEl: ".swiper-button-prev-collection-slider",
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
  var sliderswipersection = new Swiper(".image-slider-autoplay-section", {
    slidesPerView: 5,
    spaceBetween: 40,
    speed: 4000,
    direction: "horizontal",
    freeMode: true,
    autoplay: {
      delay: 0,
    },
    loop: true,
    breakpoints: {
      320: {
        slidesPerView: 2,
      },
      475: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 5,
      },
    },
  });
  // Custom Favorites
  var cutomerfaoruiteswiper = new Swiper(".customer-favorites-slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination-customer",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-customer",
      prevEl: ".swiper-button-prev-customer",
    },

    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  // slider Card  ---- custom-block-slider-section

  var customBlockSlider = new Swiper(".custom-block-slider-section", {
    slidesPerView: 4,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  $(document).on("click", ".tab_tag_item", function () {
    var value = $(this).data("value");
    $(this).addClass("active").siblings().removeClass("active");
    $(".tag_content_item").removeClass("active");
    $(".tag_content_main .tag_content_item").each(function () {
      var getvalue = $(this).data("title");
      if (value == getvalue) {
        $(this).addClass("active");
      }
    });
  });

  var cards = document.querySelectorAll(".card_block");

  [...cards].forEach((card) => {
    card.addEventListener("click", function () {
      card.classList.toggle("is-flipped");
    });
  });

  // Peter：2025-03-20
  // Miranda 反馈不需要 sticky
  //  $(window).scroll(function(){
  //   var aTop = $('.product_main').height();
  //   if($(this).scrollTop()>=aTop){
  //    $('.product .buy-buttons').addClass('add_sticky');
  //   }else{
  //      $('.product .buy-buttons').removeClass('add_sticky');
  //   }
  // });


      // FEATURED COLLECTION general_tab
  $(".general_image_content_tab_title__grid_item:first").addClass("general_tab_active");
  $(".general_image_content_tab__conetnt:first .general_image_content_tab__conetnt_inner").addClass("general_tab_active");
  $(".general_image_content_tab_title__grid_item").click(function () {
    $(this).addClass("general_tab_active").siblings().removeClass("general_tab_active");
    var value_1 = $(this).attr("Data-General-Tab");
    $(".general_image_content_tab__conetnt_inner").each(function () {
      var value_2 = $(this).attr("General-Data-Content");
      if (value_1 == value_2) {
        $(this).addClass("general_tab_active");
      } else {
        $(this).removeClass("general_tab_active");
      }
    });
  });

  // STICKY PRODUCT BAR
  $(window).on('scroll', function () {
  if ($(".template-page").length && $(".general_sticky_custom_product_bar").length) {
    var scrollTop = $(this).scrollTop();

    // Check if scroll has reached or passed 500 pixels from the top
      if (scrollTop >= 600) {
        $(".general_sticky_custom_product_bar").show();
        $(".general_sticky_custom_product_bar").addClass('sticky_general_product_bar_active');
      } else {
        $(".general_sticky_custom_product_bar").hide();
        $(".general_sticky_custom_product_bar").removeClass('sticky_general_product_bar_active');
      }
    }
  });
  
  // Mega Menu Recipe Hover Logic
  function initMegaMenuRecipeHover() {
    const categoryTitles = document.querySelectorAll('.mega-menu-category-title');
    const detailBoxes = document.querySelectorAll('.mega-menu-detail-box');
    
    if (categoryTitles.length > 0 && detailBoxes.length > 0) {
      const firstCategoryTitle = categoryTitles[0];
      const firstCategory = firstCategoryTitle.getAttribute('data-category');

      // hide all detail-box
      // detailBoxes.forEach(box => {
      //   box.style.display = 'none';
      // });
      
      // show first category corresponding detail-box
      detailBoxes.forEach(box => {
        if (box.getAttribute('data-category') === firstCategory) {
          box.style.display = 'flex';
        }
      });
       // add active style to first category title
       firstCategoryTitle.classList.add('active');
      
      categoryTitles.forEach(title => {
        title.addEventListener('mouseenter', function() {
          const category = this.getAttribute('data-category');
          
          // remove active class from all category titles
          categoryTitles.forEach(t => {
            t.classList.remove('active');
          });
          
          // add active class to current element
          this.classList.add('active');
          
          // hide all detail-box
          detailBoxes.forEach(box => {
            box.style.display = 'none';
          });
          
          // show matching detail-box
          detailBoxes.forEach(box => {
            if (box.getAttribute('data-category') === category) {
              box.style.display = 'flex';
            }
          });
        });
      });
      
      // when mouse enter mega-menu-recipe area, show corresponding detail-box
      const MegamenuChildList = document.querySelectorAll(".hasMegamenuChildList");
      if (MegamenuChildList.length > 0) {
        MegamenuChildList.forEach(item => {
          item.addEventListener('mouseenter', function() {
            const linkTitle = item.getAttribute('data-link-title');
            if (linkTitle === 'recipes') {
              categoryTitles.forEach(title => {
                title.classList.remove('active');
              });
              firstCategoryTitle.classList.add('active');
              detailBoxes.forEach(box => {
                box.style.display = 'none';
              });
              detailBoxes.forEach(box => {
                if (box.getAttribute('data-category') === firstCategory) {
                  box.style.display = 'flex';
                }
              });
            }
          });
        });
      }
    }
  }
  
  // initialize mega-menu hover logic
  initMegaMenuRecipeHover();
  
  // listen DOM change, ensure dynamic loaded content can also work
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // check if there is a new mega-menu element added
        const hasNewMegaMenu = Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType === 1) { // element node
            return node.querySelector('.mega-menu-category-title') || 
                   node.querySelector('.mega-menu-detail-box') ||
                   node.classList.contains('mega-menu-category-title') ||
                   node.classList.contains('mega-menu-detail-box');
          }
          return false;
        });
        
        if (hasNewMegaMenu) {
          initMegaMenuRecipeHover();
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// summer-sizzle page slider

if ($(window).width() < 767) {
  const swiper = new Swiper(".round_slider", {
    slidesPerView: 1,
    spaceBetween: 10,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
    },
  });
}

(() => {
  // for all external links, open in new tab
  const links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname && !links[i].hasAttribute("target")) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }

  // set auto height for containers with .autoheight class
  function setContainerHeight() {
    const containers = document.querySelectorAll(".autoheight");

    containers.forEach((container) => {
      const image = container.querySelector("img");

      if (image) {
        const width = container.offsetWidth;
        const ratio = image.naturalHeight / image.naturalWidth;
        const height = width * ratio;

        container.style.height = `${height}px`;
      }
    });
  }
  setContainerHeight();
  window.addEventListener("resize", setContainerHeight);
})();





